// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../node_modules/rescript/lib/es6/curry.js";
import * as ApiUtils$Catalyst from "../../../../../node_modules/@porterin/catalyst/src/utils/ApiUtils.bs.js";
import * as CreateCustomerRepoConfig from "./CreateCustomerRepoConfig.bs.js";

var dummCreateCustomerResponse = {
    "customer_id": 675,
    "status": "ok"
  };

function createCustomer(_customer, _country) {
  return new Promise((function (resolve, param) {
                  return resolve({
                              TAG: /* Success */0,
                              _0: dummCreateCustomerResponse
                            });
                })).then(function (result) {
              return ApiUtils$Catalyst.resolveRepoResponse(function (param) {
                          return Curry._1(CreateCustomerRepoConfig.CreateCustomerResponseConveror.execute, result);
                        });
            });
}

var CreateCustomerRepo = {
  createCustomer: createCustomer
};

export {
  CreateCustomerRepo ,
  
}
/* CreateCustomerRepoConfig Not a pure module */
